import {
  Conditional,
  CustomStyledLabel,
  RequestServiceCalendar,
  RequestServiceCalendarWeek,
  RequestServiceCalenderInfo,
  RequestServiceMonthDropdown
} from '@cat-ecom/pcc-components';
import styles from '../request-equipment-service.module.scss';
import { useState } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { REQUIST_SERVICE_CALENDER } from '../constant';
import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import { RequestServiceFieldErrorProps } from '../types';
import RequestEquipmentServiceTimeRadioInput from '../request-equipment-service-time-radioinput';

const RequestEquipmentServiceCalenderWrapper = ({ isMobile }) => {
  const t = useTranslations();
  const {
    getValues,
    control,
    formState: { errors }
  } = useFormContext();
  const { append, remove } = useFieldArray({
    control,
    name: 'preferredDateTime.dates',
    rules: {
      required: { value: true, message: t('RS_MIN_DATE_LIMIT') },
      maxLength: {
        value: REQUIST_SERVICE_CALENDER.MAX_DATE,
        message: t('RS_MAX_DATE_LIMIT')
      }
    }
  });
  const selectedDates = useWatch({
    name: 'preferredDateTime.dates',
    control
  });
  const customDateError = (
    errors.preferredDateTime as RequestServiceFieldErrorProps
  )?.dates['root'].message;
  const dropdownStartDate = getValues('preferredDateTime.month');
  const [startDate, setStartDate] = useState(dropdownStartDate);
  const [weekStartDate, setWeekStartDate] = useState(dropdownStartDate);

  const handleDateSelect = (date) => {
    const selectedIndex =
      selectedDates?.findIndex((selectedDate) => {
        return selectedDate.formattedDate === date.formattedDate;
      }) ?? -1;
    if (selectedIndex === -1) {
      return append(date);
    }
    return remove(selectedIndex);
  };
  const handleSelect = (date) => {
    setStartDate(new Date(date.detail.value));
  };

  const maxDaysMessage = (
    <RequestServiceCalenderInfo>
      <span className="u-color--MediumGray">{t('MAX_30_DAYS')}</span>
    </RequestServiceCalenderInfo>
  );
  return (
    <div className="px-md-3">
      <div className="d-flex mb-n2 flex-column flex-md-row justify-content-md-between">
        <div className={styles['request-service__rtl-lang']}>
          <CatHeading variant="label" className="d-block pb-3 mb-2 pb-md-1">
            <CustomStyledLabel>{t('SPECIFY_PREF_DATE')}</CustomStyledLabel>
          </CatHeading>
          <Conditional test={!isMobile}>
            <RequestServiceCalendarWeek weekStartDate={weekStartDate} />
          </Conditional>
        </div>

        <div className={styles['request-service__month_dropdown-container']}>
          <RequestServiceMonthDropdown
            name="preferredDateTime.month"
            handleSelect={handleSelect}
            setWeekStartDate={setWeekStartDate}
            size="sm"
          />
        </div>
      </div>
      <RequestServiceCalendar
        startDate={startDate}
        onClickHandler={handleDateSelect}
        selectedDates={selectedDates}
        weekStartDate={weekStartDate}
        setWeekStartDate={setWeekStartDate}
        customDateError={customDateError}
        classname="border-LightGray"
        selectedClassname="border-black"
      />
      <div
        className={`${styles['request-service__rtl-lang']} 
          mt-0 mt-md-2 ms-2 ms-md-0 mb-4`}
      >
        <Conditional test={customDateError} fallback={maxDaysMessage}>
          <div className="ps-md-4 ms-md-3">
            <RequestServiceCalenderInfo color="error">
              {customDateError}
            </RequestServiceCalenderInfo>
          </div>
        </Conditional>
      </div>
      <RequestEquipmentServiceTimeRadioInput isMobile={isMobile} />
    </div>
  );
};
export default RequestEquipmentServiceCalenderWrapper;
